import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AssociateClientWithSimParams } from 'lib/api/requests/client/client.requests.types';
import iotApi from '../../api/iotApi.client';
import { SimQueryKey } from '../sim/sim.hooks.keys';
import { ClientQueryKey } from './client.hooks.keys';

export function useAssociateClientWithSim() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AssociateClientWithSimParams) => {
      const res = await iotApi.client.associateClientWithSim(data);

      return res;
    },
    onSettled: () => {
      queryClient.invalidateQueries([ClientQueryKey.GET_ALL_CLIENTS]);
      queryClient.invalidateQueries([SimQueryKey.FILTERED_SIMS]);
    },
  });
}
